(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $block
        .find(".iconBox .iconBox__icon")
        .matchHeight({ property: "min-height" });
      $block
        .find(".iconBox .iconBox__title")
        .matchHeight({ property: "min-height" });
    }

    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);

    const $carousel = $block.find(".iconBoxes--slider");
    if($carousel.hasClass('slick-initialized'))
      $carousel.slick('unslick');
    $carousel.slick({
      prevArrow: $block.find(".iconBoxes-arrow--prev"),
      nextArrow: $block.find(".iconBoxes-arrow--next"),
      arrows: true,
      dots: false,
      mobileFirst: true,
      slidesToScroll: 1,
      swipe: true,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 7000,
    });
  };

  $(document).ready(function () {
    $(".block--icon-boxes").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=icon-boxes",
      initializeBlock
    );
  }
})(jQuery);
